// extracted by css-extract-rspack-plugin
export default {"inputContainer":"inputContainer-jUFoZU","inputWrapper":"inputWrapper-GmjSbT","messageInput":"messageInput-GKFKBo"};